import { getFetch } from '../fetch';
import { apiConfig } from '../config';

/** Настоящий тип в modules с тем же названием */
type TeacherReserveActivity = unknown;

export function getTeacherReserveActivities<T extends TeacherReserveActivity>(): Promise<T[]> {
    const { apiGetTeacherReserveActivities } = apiConfig.getStaticUrls();

    return getFetch(apiGetTeacherReserveActivities);
}
